import { useEffect, useMemo, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import useDarkMode from '@/hooks/useDarkMode'
import { useTeamColors } from '@/hooks/useTeamColors'

export const StartingCountdown = ({
  onComplete = () => {},
  speakingRole,
  title = '',
  bg = '',
  noOverlay = false,
}) => {
  const [count, setCount] = useState(3)
  const [show, setShow] = useState(true)
  const isDark = useDarkMode()
  const { bgClass } = useTeamColors({ speakingRole })

  useEffect(() => {
    if (count > 1) {
      const timer = setTimeout(() => setCount(count - 1), 1000)
      return () => clearTimeout(timer)
    } else {
      const timer = setTimeout(() => setShow(false), 1000)
      return () => clearTimeout(timer)
    }
  }, [count])

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {show && (
        <div
          className={`absolute w-full h-full inset-0 flex flex-col items-center justify-center ${
            !noOverlay ? `${isDark ? 'bg-black' : 'bg-gray-200'} bg-opacity-75` : ''
          }`}
          style={{ zIndex: 999 }}
        >
          {title && <h1 className="text-3xl font-bold mb-16 -mt-16">{title}</h1>}
          <motion.div
            key={count}
            initial={{ scale: 0.8, opacity: 0 }}
            exit={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: [1, 1.2, 1], opacity: 1 }}
            transition={{ duration: 0.8 }}
            className={`w-28 h-28 rounded-full bg-opacity-30 border flex items-center justify-center ${bgClass}`}
          >
            <span className="text-6xl font-bold text-white">{count}</span>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
